<template>
	<div id="app">
		<!-- <div style="position:absolute;color:yellow;top:10px;right:20px;font-size:10px;z-index: 999;cursor:pointer;" @click="$router.push('/4dm1n').catch(err => {})">{{ appVersion }}</div> -->
		<!-- Nep-dom - Logo -->
		<div v-if="$route.path=='/'" class="nep-dom_logo" @click.stop="$router.push('/').catch(err => {})">
			<img :src="require('@/assets/img/logo_nep-dom.png')"/>
			<div class="logo-text">Nep-dom.si</div>
		</div>
		<!-- <div v-else class="nep-dom_logo" @click.stop="$router.push('/').catch(err => {})"><img :src="require('@/assets/img/remax_balloon.png')"/></div> -->
	
		<!-- Nep-dom Site - Language select -->
		<!-- <nav v-if="!$route.path.includes('/4dm1n')" class="p-0 nav-site">
          <div class="float-right mr-2 nav-site-sel">
			<div class="lang-text" :class="($route.path=='/')?'cl-white':'cl-grey'" :style="($i18n.locale=='de')?'cursor:default;font-weight:700':''" @click.stop="selectLanguage('de')">DE</div>
			<div class="float-left fw800 text-center w-auto pt-2" :class="($route.path=='/')?'cl-white':'cl-grey'" style="font-size:0.5em;">|</div>
			<div class="lang-text" :class="($route.path=='/')?'cl-white':'cl-grey'" :style="($i18n.locale=='en')?'cursor:default;font-weight:700':''" @click.stop="selectLanguage('en')">EN</div>
          </div>

		</nav> -->
		<!-- Nep-dom Site - Burger menu -->
		<!-- <nav v-if="!$route.path.includes('/4dm1n')" v-b-toggle.sidebar-right class="p-0" style="z-index:15;" :style="($route.path=='/')?'color:#eee;':'color:#999;'">
			<i class="fas fa-bars"></i>
		</nav> -->

		<!-- Nep-dom Site - Sidebar navigation -->
		<b-sidebar v-if="!$route.path.includes('/4dm1n')" id="sidebar-right" text-variant="light" right class="bg-dark">
			<div class="px-3 py-2">
				<ul class="list-group text-right bg-transparent fs15 cl-white" style="border: none;">
					<li v-for="(option, key) in menuOptions" :key="key" class="list-group-item bg-transparent" :class="($route.path==option.route)?'fw700':''" @click.stop="$router.push(option.route).catch(err => {})">{{option.name}}
						<ul v-if="option.children" class="list-group text-right cl-white">
						<li v-for="(child, ckey) in option.children" :key="ckey" class="list-group-item bg-transparent p-0 fs07" :class="($route.path==child.route)?'fw700':'fw300'" @click.stop="$router.push(child.route).catch(err => {})">{{child.name}}</li>
						</ul>
					</li>
					<li class="list-group-item text-right bg-transparent fs15 cl-white"><span></span></li>
					<li class="list-group-item text-right bg-transparent fs15 cl-white"><span></span></li>
				</ul>
			</div>
		</b-sidebar>

		<!-- Nep-dom CMS navigation -->
		<b-container v-if="$store.getters.isLoggedIn && $route.path.includes('/4dm1n') && !$store.getters.getPasswordChange" class="sm-none prl-outside text-left" style="margin-top:160px;">
			<b-row>
				<b-col cols="12" class="p-0" style="font-size:1.3em;">
				<router-link to="/4dm1n">{{$t('bulletin')}}</router-link> |
				<router-link to="/4dm1n/news">{{$t('memo')}}</router-link> |
				<router-link to="/4dm1n/team">{{$t('team')}}</router-link> |
				<router-link to="/4dm1n/myprofile">{{$t('myprofile')}}</router-link> |
				<router-link to="/4dm1n/hours">{{$t('timeacc')}}</router-link>
				</b-col>
			</b-row>
		</b-container>

		<!-- Nep-dom Intranet Mobile navigation -->
		<div id="nav" class="info-bar" v-if="$store.getters.isLoggedIn && $route.path.includes('/4dm1n') && !$store.getters.getPasswordChange">
			<div class="info-bar-item" v-if="userData.userpic"><img :src="$store.getters.getDomain+'pictures/'+userData.userpic"/></div>
			<div class="info-bar-item" v-if="userData.firstname && userData.lastname">{{userData.firstname}} {{userData.lastname}}</div>
			<div class="info-bar-item" v-else>{{userData.email}}</div>
			<div class="info-bar-item sm-none">|</div>
			<div class="info-bar-item logout sm-none" @click="logout()">{{$t('logout')}}</div>
			<div class="info-bar-item sm-show">|</div>
			<div class="info-bar-item sm-show cursorp" v-b-toggle.sidebar-right-intranet><i class="fas fa-bars"></i></div>
		</div>

		<!-- Nep-dom Intranet Mobile - Sidebar navigation -->
		<b-sidebar v-if="$route.path.includes('/4dm1n') && $store.getters.isLoggedIn" id="sidebar-right-intranet" text-variant="light" right class="bg-dark">
			<div class="px-3 py-2">
				<ul class="list-group text-right bg-transparent fs15 cl-white" style="border: none;">
				<li class="list-group-item bg-transparent fs08" style="margin-top: -20px;" @click.stop="logout()">{{$t('logout')}}</li>
				<li v-for="(option, key) in menuOptionsIntranet" :key="key" class="list-group-item bg-transparent" :class="($route.path==option.route)?'fw700':''" @click.stop="$router.push(option.route).catch(err => {})">{{option.name}}
					<ul v-if="option.children" class="list-group text-right cl-white">
					<li v-for="(child, ckey) in option.children" :key="ckey" class="list-group-item bg-transparent p-0 fs07" :class="($route.path==child.route)?'fw700':'fw300'" @click.stop="$router.push(child.route).catch(err => {})">{{child.name}}</li>
					</ul>
				</li>
				</ul>
			</div>
		</b-sidebar>

		<transition name="fade" mode="out-in">
			<router-view/>
		</transition>

		<footer v-if="!$route.path.includes('/4dm1n')" class="footer mt-3 cl-white" style="background-color: #307bad;">
			<div class="container">
				<div class="row pt-3 pb-3">
					<div class="d-none d-md-block col-md-3 text-left m-0 footer-box" style="font-size:13px;font-weight:bold;">
						<ul class="list-unstyled mt-3">
							Nep-dom.si
						</ul>
					</div>
					<div class="d-none d-md-block col-md-3 text-left m-0 footer-box">
						<ul class="list-unstyled mt-3 fs08">
							Andreja Raušl, mag.manag.
							<!-- <li class="list-item mb-2" @click="$router.push('/company').catch(err => {})">{{$t('company')}}</li>
					<li class="list-item mb-2" @click="$router.push('/whatwedo').catch(err => {})">{{$t('whatwedo')}}</li>
					<li class="list-item mb-2" @click="$router.push('/references').catch(err => {})">{{$t('references')}}</li>
					<li class="list-item mb-2" @click="$router.push('/gerainside').catch(err => {})">{{$t('gerainside')}}</li> -->
						</ul>
					</div>
					<div class="d-none d-md-block col-md-3 text-left m-0 footer-box">
						<ul class="list-unstyled mt-3 fs08">
							Licencirana nepremičninska posrednica
							<!-- <li class="list-item mb-2" @click="$router.push('/jobs').catch(err => {})">{{$t('lookingfor')}}</li>
							<li class="list-item mb-2" @click="$router.push('/contact').catch(err => {})">{{$t('contact')}}</li>
							<li class="list-item mb-2" @click="$router.push('/impressum').catch(err => {})">{{$t('pubinfo')}}</li>
							<li class="list-item mb-2" @click="$router.push('/agb').catch(err => {})">{{$t('dataprotection')}}</li>
							<li class="list-item mb-2" @click="$router.push('/4dm1n').catch(err => {})">CMS</li> -->
						</ul>
					</div>
					<div class="d-none d-md-block col-md-3 text-left m-0 fw300" style="padding-left:5.5%;">
						<ul class="list-unstyled mt-3 text-left fs08">
							T: <a href="tel:+386 41 223 770 3445">+386 41 223 770</a><br>
							E: <a href="mailto:rausl.andreja@gmail.com">rausl.andreja@gmail.com</a>
						<!-- <li class="list-item"><a class="fs10" style="text-decoration:none;" href="https://www.facebook.com/107701770875035" target="_blank" rel="noopener"><i class="fab fa-facebook"></i>&nbsp;&nbsp;Facebook</a></li>
						<li class="list-item" @click="$router.push('/4dm1n').catch(err => {})">&nbsp;&nbsp;Content Management System</li> -->
						</ul>
					</div>
					<div class="d-sm-block d-md-none text-left m-0 fw300" style="padding-left:5.5%;font-size:30px;padding-top:20px;">
						<div class="row mx-auto">
							<div class="col-6 text-center"> <!--  @click="$router.push('/4dm1n').catch(err => {})" -->
						    <a href="tel:+386 41 223 770"><i class="fas fa-phone-alt fa-2x cl-white"></i></a>
							</div>
							<div class="col-6 text-center">
								<a href="mailto:rausl.andreja@gmail.com"><i class="far fa-envelope fa-2x cl-white"></i></a>
							</div>
							<!-- <div class="col-4 text-center">
								<a style="text-decoration:none;" href="https://www.facebook.com/107701770875035" target="_blank" rel="noopener"><i class="fab fa-facebook fa-2x cl-white"></i></a>
							</div> -->
				<!--

							<div class="col-3 text-center" @click="$router.push('/4dm1n')">
								<i class="fab fa-youtube"></i>
							</div>
				-->
							<div class="col-11 text-center mt-4 p-0" style="font-size:4vw;">
								<span style="font-weight:bold;font-family:Gotham-Light">Andrejka Raušl, mag.manag.</span><br>Licencirana nepremičninska posrednica
							</div>
							<div class="col-11 text-center mt-4 p-0" style="font-size:3vw;">
								<a href="https://ribuild.si/" target="_blank"><span style="font-weight:bold;font-family:Gotham-Light">&#169;2025  Izdelava: ri{build}</span></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
		<app-modal @closeModal="$store.state.modal.show=false" v-if="$store.state.modal.show" width="50%">
			<div slot="title">
				<div class="float-left" style="width:30px;" :style="$store.state.modal.color"><i class="fas fa-exclamation-circle fa-2x" :style="$store.state.modal.color"></i></div>
				<div class="float-right ml-2 modal-header-text" style="width:calc(100% - 50px);" :style="$store.state.modal.color">{{$store.state.modal.message}}</div>
			</div>
			<div slot="content" class="text-left bb-gera"></div>
			<div slot="buttons-right">
				<b-button class="btn-confirm" style="background-color: #307bad !important;color:white !important;" size="sm" @click="$store.state.modal.show=false">{{$store.state.modal.buttonText}}</b-button>
			</div>
		</app-modal>
		<footer>
			<cookie-law position="bottom" :message="$t('cookies')" :buttonText="$t('btnText')" :buttonLink="$store.state.domain+'agb'" :buttonLinkText="$t('more')"></cookie-law>
		</footer>
  	</div>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex'
import appModal from '@/components/Modal.vue'
import CookieLaw from 'vue-cookie-law'
export default {
	name: 'app',
	components: {
		appModal,
		CookieLaw
	},
	data () {
		return {
			// windowWidth: 1920,
			selectedLanguage: { name: this.$t('german'), flag: 'flagAuDe.png', langCode: 'de', selected: false },
			showLanguageSelect: false,
			languages: [
				{ name: this.$t('german'), flag: 'flagAuDe.png', langCode: 'de', selected: false },
				{ name: this.$t('english'), flag: 'flagEng.png', langCode: 'en', selected: false }
			],
			menuOptions: [
				{
					name: this.$t('company'),
					route: '/company',
					children: [
						{
							name: this.$t('team'),
							route: '/company/team'
						},
						{
							name: this.$t('history'),
							route: '/company/history'
						},
						{
							name: this.$t('global'),
							route: '/company/overtheworld'
						}
					]
				},
				{
					name: this.$t('whatwedo'),
					route: '/whatwedo'
				},
				{
					name: this.$t('references'),
					route: '/references'
				},
				{
					name: this.$t('gerainside'),
					route: '/gerainside'
				},
				{
					name: this.$t('jobs'),
					route: '/jobs',
					children: [
						{
							name: this.$t('applyeasily'),
							route: '/jobs/apply'
						}
					]
				},
				{
					name: this.$t('contact'),
					route: '/contact'
				},
				{
					name: this.$t('pubinfo'),
					route: '/impressum'
				},
				{
					name: this.$t('dataprotection'),
					route: '/agb'
				},
				{
					name: 'CMS',
					route: '/4dm1n'
				}
			],
			menuOptionsIntranet: [
				{
					name: this.$t('bulletin'),
					route: '/4dm1n'
				},
				{
					name: this.$t('memo'),
					route: '/4dm1n/news'
				},
				{
					name: this.$t('team'),
					route: '/4dm1n/team'
				},
				{
					name: this.$t('myprofile'),
					route: '/4dm1n/myprofile'
				},
				{
					name: this.$t('timeacc'),
					route: '/4dm1n/hours'
				}
			]
		}
	},
	methods: {
	  setAppWidth () {
      store.dispatch('setAppWidth', Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0))
    },
		selectLanguage (langCode, refresh = true) {
			// this.showLanguageSelect = false
			if (langCode === this.$i18n.locale && refresh) return false

			this.selectedLanguage = langCode

			if (refresh) {
				localStorage.setItem('locale', langCode)
				// Send information to backend!

				this.$router.go(0)
			}
		},
		logout() {
			store.dispatch('logout');
			if (this.$router.path!=='/4dm1n') this.$router.push('/4dm1n').catch(err => {})
		}
	},
	mounted () {
		const lang = localStorage.getItem('locale')
		const selLang = this.$i18n.locale
		if (selLang) this.selectLanguage(selLang, false)
	},
	computed: {
    ...mapState({
			appVersion: state => state.version,
      appWidth: state => state.appWidth,
			isLoggedIn: state => state.loginSuccess,
			// isPasswordChange:  state => state.passwordchange,
			// hasLoginErrored: state => state.loginError,
			// getLoginErrorText: state => state.errorText,
			// getUserName: state => state.userData.userName,
			// getUserPass: state => state.userData.userPass,
			// getUserData: state => state.userData,
			// getToken: state => state.userData.accessToken,
			// getDomain: state => state.domain,
			// getUserRoles: state => state.userData.roles,
			// getPasswordChange: state => state.userData.passwordchange
    //   userData: state => state.userData,
    //   entryTypes: state => [{ id: null, text: '' }, ...state.entryTypes],
    //   tsTypes: state => [{ id: null, text: '' }, ...state.tsTypes],
    //   holidays: state => state.holidays,
    //   localeData: state => state.localeData,
    //   isAdmin: state => (state.userData.isAdmin === 1)
    }),
		userData () {
			return store.getters.getUserData;
		},
		locale () {
			return this.$i18n.locale
		}
	},
  created () {
    this.setAppWidth()
    window.addEventListener('resize', () => {
      this.setAppWidth()
    })
  },
}
</script>
<style>
	@import './assets/css/App.css';
	.Cookie { 
		background: rgba(0,0,0,0.7) !important;
		font-size: 1vw;
		color:white !important;
	}
	.Cookie__button {
		background: #307bad !important;
	}
	.Cookie__button:hover {
		background: #306bad !important;
	}
	@media only screen and (max-width: 576px) {
		.Cookie--base {
			padding:0 !important;
		}
		.Cookie__content {
			font-size: 3vw;
			padding:0;
			margin:0;
			margin-top:2vw;
		}
		.Cookie__button {
			padding:2vw 5vw !important;
			font-size: 2vw !important;
		}
	}
</style>
<style scoped>
	.lang-text {
		 float: left; text-align: center; padding-right: 0.5rem; padding-left: 0.5rem; padding-top: 0.5rem; font-family:Arial;font-size:20px;
	}
	.list-item {
		margin-bottom:5px;
	}
	a, a:hover {
		text-decoration:underline;
		color: white
	}
	.footer-box {
		border-right:solid 1px white !important;
		padding-left:5.5% !important;
		font-weight:300 !important;
		line-height:1.2 !important;
	}
	.language-option, .language-option-na { width: 105px;background: white;text-align: left;padding-left:5px; }
	.language-option:hover {
		background: #eee;
		-webkit-box-shadow: 5px 5px 10px -8px rgba(0,0,0,0.53);
		-moz-box-shadow: 5px 5px 10px -8px rgba(0,0,0,0.53);
		box-shadow: 5px 5px 10px -8px rgba(0,0,0,0.53);
	}
	.nav-site {
		z-index:5;top: 11px;right: 80px;
	}
	.nav-site-sel {
		 position:relative;margin-top: 1rem;padding-right: 1rem;
	}
	.nav-site-sel img {
		 width: 32px;
	}
	.nav-site-list {
		 position:absolute;width:auto;height:auto;top:15px;right:0;z-index: 10;cursor:default;font-size:12px;
	}
	@media only screen and (max-width: 576px) {
		.nav-site-sel {
			margin-top: 6px;padding-right: 0;
		}
	}
</style>
<i18n>
{
	"sl": {
		"slovensko": "Slovensko",
		"german": "Nemško",
		"english": "Angleško",
		"bulletin": "Oglasna deska",
		"memo": "Novice",
		"team":"Tim",
		"myprofile": "Moj profil",
		"timeacc": "Stundenkonto",
		"logout": "Odjava",
		"company": "Podjetje",
		"whatwedo": "Kaj delamo",
		"references": "Reference",
		"gerainside": "Nep-dom interno",
		"lookingfor": "Iščemo",
		"contact": "Kontakt",
		"pubinfo": "Impressum",
		"dataprotection": "Varovanje podatkov",
		"history": "O nas",
		"global": "Po svetu",
		"jobs": "Dela",
		"applyeasily": "Einfach bewerben",
		"cookies": "Ta spletna stran uporablja piškotke za izboljšanje uporabniške izkušnje.",
		"more": "Preberite več...",
		"btnText": "V redu"
	},
	"de": {
		"german": "Deutsch",
		"english": "Englisch",
		"bulletin": "Pinnwand",
		"memo": "News",
		"team":"Team",
		"myprofile": "Mein Profil",
		"timeacc": "Stundenkonto",
		"logout": "Abmelden",
		"company": "Unternehmen",
		"whatwedo": "Was wir tun",
		"references": "Referenzen",
		"gerainside": "GERA Inside",
		"lookingfor": "Wir suchen",
		"contact": "Kontakt",
		"pubinfo": "Impressum",
		"dataprotection": "Datenschutz",
		"history": "Geschichte",
		"global": "Weltweit",
		"jobs": "Jobs",
		"applyeasily": "Einfach bewerben",
		"cookies": "Diese Webseite verwendet Cookies, um die Bedienfreundlichkeit zu erhöhen.",
		"more": "Mehr lesen",
		"btnText": "Ok!"
	},
	"en": {
		"german": "German",
		"english": "English",
		"bulletin": "Pinnwand",
		"memo": "News",
		"team":"Team",
		"myprofile": "Mein Profil",
		"timeacc": "Stundenkonto",
		"logout": "Logout",
		"company": "Company",
		"whatwedo": "What we do",
		"references": "References",
		"gerainside": "GERA Inside",
		"lookingfor": "We are looking for",
		"contact": "Contact",
		"pubinfo": "Publishing information",
		"dataprotection": "Data protection",
		"history": "History",
		"global": "Global",
		"jobs": "Jobs",
		"applyeasily": "Apply",
		"cookies": "This website uses cookies to ensure you get the best experience on our website.",
		"more": "More info",
		"btnText": "Ok!"
	}
}
</i18n>
